import { createSlice } from '@reduxjs/toolkit';
import { fetchPersonDetails } from '../fetch/fetchPersonDetails';
import { createReducer } from './createReducer';

let fetch = fetchPersonDetails;
const personDetails = createSlice({
    name: "personDetails",
    initialState: {
        isLoading: false,
        value: null,
        isError: false,
        showDialog: false,
        rbr: null,
    },
    extraReducers: (builder) => {
        builder.addCase(fetch.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(fetch.fulfilled, (state, action) => {
            state.isLoading = false;

            let data = action.payload;

            state.value = data;
        })
        builder.addCase(fetch.rejected, (state, action) => {
            state.isError = true;
        })
    },
    reducers: {
        setShowDialog(state, action) {
            state.showDialog = action.payload;
        },
        setRbr(state, action) {
            state.rbr = action.payload;
            state.showDialog = true;



        }
    }
});


export const selectPersonDetails = (state) => state.personDetails.value
export const selectLoadingPersonDetails = (state) => state.personDetails.isLoading
export const selectShowPersonDetailsDialog = (state) => state.personDetails.showDialog
export const selectPersonDetailsRbr = (state) => state.personDetails.rbr
export const { setShowDialog: setShowDialog, setRbr: setRbr } = personDetails.actions

export const selectIsError = (state) => state.personDetails.isError  

export default personDetails.reducer

